import React from 'react';
import PropTypes from 'prop-types';

import { Portal } from 'components/Portal';

import './style.scss';

const ModalAttention = ({ onClose, onSubmit, headerText, bodyText, submitTextButton, cancelTextButton, className }) => {
  return (
    <Portal id="modal-attention" className={className} onClose={onClose}>
      <div className="modal-title">
        <div className="header-title">{headerText}</div>
      </div>
      <div className="modal-body-attention">{bodyText}</div>
      <div className="modal-footer-attention">
        <div className="button submit" onClick={onSubmit}>
          {submitTextButton}
        </div>
        <div className="button close" onClick={onClose}>
          {cancelTextButton}
        </div>
      </div>
    </Portal>
  );
};

ModalAttention.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  bodyText: PropTypes.any,
  className: PropTypes.string,
  submitTextButton: PropTypes.string,
  cancelTextButton: PropTypes.string,
};

ModalAttention.defaultProps = {
  headerText: 'Закрытие окна',
  bodyText: 'Вы действительно хотите закрыть эту страницу? Все несохраненные данные будут удалены.',
  submitTextButton: 'Закрыть',
  className: 'attention',
  cancelTextButton: 'Отмена',
};
export { ModalAttention };
